if (!customElements.get("products-slider")) {
  customElements.define(
    "products-slider",
    class ProductsSliders extends HTMLElement {
      constructor() {
        super();
        this.mainSlider = null;
        this.promoSlider = null;
        this.lastScrollY = 0;
        this.isScrollTriggered = false;
        this.scrollHandler = this.handleScroll.bind(this);
        this.ticking = false; // Pour requestAnimationFrame
      }

      connectedCallback() {
        // Lire les options depuis les data-attributes
        this.scrollTriggerEnabled = this.dataset.scrollTrigger !== 'false'; // Activé par défaut
        this.scrollThreshold = parseFloat(this.dataset.scrollThreshold) || 0.5; // 50% par défaut
        
        this.interval = setInterval(() => {
          const mainSliderContainer = this.querySelector(
            ".wt-products-slider__slider--products [data-swiper]",
          );
          const promoSliderContainer = this.querySelector(
            ".wt-products-slider__slider--promo [data-swiper]",
          );

          const mainSlider = mainSliderContainer?.swiper;
          const promoSlider = promoSliderContainer?.swiper;

          if (mainSlider && promoSlider) {
            clearInterval(this.interval);
            this.mainSlider = mainSlider;
            this.promoSlider = promoSlider;
            this.initializeSync(mainSlider, promoSlider);
            
            // Initialiser le scroll trigger seulement si activé
            if (this.scrollTriggerEnabled) {
              this.initializeScrollTrigger();
            }
          }
        }, 100);
      }

      initializeScrollTrigger() {
        this.lastScrollY = window.scrollY;
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
      }

      handleScroll() {
        if (!this.mainSlider || !this.promoSlider) return;

        // Utiliser requestAnimationFrame pour de meilleures performances
        if (!this.ticking) {
          requestAnimationFrame(() => {
            this.updateSlideOnScroll();
            this.ticking = false;
          });
          this.ticking = true;
        }
      }

      updateSlideOnScroll() {
        const rect = this.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const currentScrollY = window.scrollY;
        
        const sectionTop = rect.top;
        const sectionBottom = rect.bottom;
        const sectionHeight = rect.height;
        
        // Vérifier si la section est visible
        const isVisible = sectionTop < viewportHeight && sectionBottom > 0;
        
        if (!isVisible) {
          return;
        }

        // Calculer le scroll progress (0 à 1)
        // Ajusté pour que le changement se fasse quand la section est bien visible
        const scrollProgress = Math.max(0, Math.min(1, 
          (viewportHeight * this.scrollThreshold - sectionTop) / (sectionHeight * 0.8)
        ));

        // Nombre total de slides
        const totalSlides = this.mainSlider.slides.length;
        const currentIndex = this.mainSlider.activeIndex;

        // Calculer l'index cible basé sur le progress
        let targetSlideIndex;
        
        if (scrollProgress <= 0) {
          targetSlideIndex = 0;
        } else if (scrollProgress >= 1) {
          targetSlideIndex = totalSlides - 1;
        } else {
          // Répartir les slides sur la progression du scroll
          targetSlideIndex = Math.floor(scrollProgress * totalSlides);
          targetSlideIndex = Math.min(targetSlideIndex, totalSlides - 1);
        }

        // Changer de slide avec une animation fluide
        if (targetSlideIndex !== currentIndex) {
          this.mainSlider.slideTo(targetSlideIndex, 300); // 300ms de transition
        }

        this.lastScrollY = currentScrollY;
      }

      initializeSync(mainSlider, promoSlider) {
        const updateCssVariables = (slider) => {
          const activeSlide = slider.slides[slider.activeIndex];

          if (activeSlide) {
            const activeSlideStyles = getComputedStyle(activeSlide);

            const cssVariableValue = activeSlideStyles
              .getPropertyValue("--slide-text-color")
              .trim();

            this.style.setProperty("--slider-bullets-color", cssVariableValue);
          }
        };

        updateCssVariables(mainSlider);
        updateCssVariables(promoSlider);

        mainSlider.on("slideChange", () => {
          promoSlider.slideTo(mainSlider.activeIndex);
          updateCssVariables(mainSlider);
        });

        promoSlider.on("slideChange", () => {
          mainSlider.slideTo(promoSlider.activeIndex);
          updateCssVariables(promoSlider);
        });
      }

      disconnectedCallback() {
        if (this.interval) {
          clearInterval(this.interval);
        }
        window.removeEventListener('scroll', this.scrollHandler);
      }
    },
  );
}